// extracted by mini-css-extract-plugin
export default {"particleContainer":"BackgroundParticles_particleContainer__wUbD5","particle":"BackgroundParticles_particle__ZcfVE","openingParticle":"BackgroundParticles_openingParticle__IqNuB"};